export const createReducer = <S>(reducer: { [key: string]: Function }, state: S, action: { [key: string]: any }) =>
  // @ts-expect-error TS2722 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  reducer[action.type] ? reducer[action.type](state, action) : state;
